import React, { useState } from 'react';
import { useTranslations } from 'use-intl';
import Select from '@/UIlibrary/Select/Select';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { useSupabaseStore } from '../supabaseStore';
import { useChatStore } from '../useChat';
import { ChatTag } from '../types';
import ConfirmModal from '@/stories/Components/ConfirmModal/ConfirmModal';
import { tagOptions } from './utils';
interface UpdateTagModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const UpdateTagModal: React.FC<UpdateTagModalProps> = ({ isOpen, onClose }) => {
	const t = useTranslations('Support');
	const supabase = useSupabaseStore((state) => state.supabase);
	const { selectedChat } = useChatStore();
	const [selectedTag, setSelectedTag] = useState<ChatTag>(
		(selectedChat?.tag as ChatTag) ? (selectedChat?.tag as ChatTag) : ChatTag.SOPORTE
	);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	const handleUpdateTag = async () => {
		if (!supabase || !selectedChat?.id) return;
		setIsLoading(true);
		setError('');
		try {
			const { error: updateError } = await supabase
				.from('chats')
				.update({ tag: selectedTag })
				.eq('id', selectedChat.id);
			if (updateError) throw updateError;
			handleClose();
		} catch (err) {
			console.error('Error updating tag:', err);
			setError(t('errorUpdatingTag'));
		} finally {
			setIsLoading(false);
		}
	};

	const handleClose = () => {
		onClose();
		setError('');
		setSelectedTag(selectedChat?.tag ? (selectedChat.tag as ChatTag) : ChatTag.SOPORTE);
	};

	// Tag selection content
	const tagSelectionContent = (
		<div className="space-y-4">
			<div className="space-y-2">
				<Select
					label={t('tag')}
					name="tag"
					value={selectedTag}
					options={tagOptions}
					onChange={(e) => setSelectedTag(e.target.value as ChatTag)}
				/>
			</div>
			{error && (
				<Typography color="error" size="sm">
					{error}
				</Typography>
			)}
		</div>
	);

	return (
		<ConfirmModal
			isOpen={isOpen}
			onClose={handleClose}
			title={t('updateTag')}
			subtitle={t('updateTagDescription')}
			confirmActionText={isLoading ? t('updating') : t('update')}
			onConfirm={handleUpdateTag}
			onCancel={handleClose}
			confirmBtnLoading={isLoading}
			confirmBtnTestId="updateTagBtn"
			cancelBtnTestId="cancelTagBtn"
			type="confirm"
			maxWidth={500}
		>
			{tagSelectionContent}
		</ConfirmModal>
	);
};

export default UpdateTagModal;
